import type { Card } from '../Widgets/Home';
import Link from 'next/link';
import { FC } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { AlertCircleFilled, ListAltOutline } from '@eqi-investimentos/icons/web';
import { Flex, Text } from '@eqi-investimentos/react';
import { SimpleGrid } from '@chakra-ui/react';
import { Icon } from '@/components/atoms/Icon';
import { IfRender } from '@/utils/jsx';
export const CoverScreens: FC<CoverScreensProps> = ({
  isFirstScreen,
  isLastScreen
}) => {
  const {
    t
  } = useTranslation('common');
  const endCards = t('screens.financialPlanning.register.form.end.cards', null, {
    returnObjects: true
  }) as Card[] | undefined;
  return <Flex direction="column" gap={24} data-sentry-element="Flex" data-sentry-component="CoverScreens" data-sentry-source-file="CoverScreens.tsx">
      <IfRender condition={isFirstScreen} data-sentry-element="IfRender" data-sentry-source-file="CoverScreens.tsx">
        <ListAltOutline boxSize="1.875rem" color="content.brand" data-sentry-element="ListAltOutline" data-sentry-source-file="CoverScreens.tsx" />
      </IfRender>
      <Text fontSize="2xl" lineHeight="140%" data-sentry-element="Text" data-sentry-source-file="CoverScreens.tsx">
        {t(`screens.financialPlanning.register.form.${isFirstScreen ? 'intro' : 'end'}.title`)}
      </Text>
      <Text lineHeight="175%" data-sentry-element="Text" data-sentry-source-file="CoverScreens.tsx">
        {t(`screens.financialPlanning.register.form.${isFirstScreen ? 'intro' : 'end'}.text`)}
      </Text>
      <IfRender condition={isFirstScreen} data-sentry-element="IfRender" data-sentry-source-file="CoverScreens.tsx">
        <Flex gap={5} bg="background.brandLight" p="0.75rem 1rem" borderRadius="lg" alignItems="center" data-sentry-element="Flex" data-sentry-source-file="CoverScreens.tsx">
          <AlertCircleFilled boxSize={24} color="content.brand" data-sentry-element="AlertCircleFilled" data-sentry-source-file="CoverScreens.tsx" />
          <Text fontSize="sm" lineHeight={6} fontWeight="light" data-sentry-element="Text" data-sentry-source-file="CoverScreens.tsx">
            {t('screens.financialPlanning.register.form.intro.infoText')}
          </Text>
        </Flex>
      </IfRender>
      <IfRender condition={isLastScreen} data-sentry-element="IfRender" data-sentry-source-file="CoverScreens.tsx">
        <SimpleGrid columns={2} gridGap={6} px={10} data-sentry-element="SimpleGrid" data-sentry-source-file="CoverScreens.tsx">
          {Array.isArray(endCards) && endCards.map(({
          icon,
          text,
          href
        }) => <Flex key={text} as={Link} href={href} direction="column" h="8.3125rem" gap={16} p="1.4763rem 0.7444rem" borderRadius="0.7444rem" bgColor="background.secondary">
                <Icon iconName={icon} color="content.brand" width={24} height={24} />
                <Text fontSize="sm" fontWeight="semibold" color="content.primary" lineHeight={5} w="75%">
                  {text}
                </Text>
              </Flex>)}
        </SimpleGrid>
      </IfRender>
    </Flex>;
};
type CoverScreensProps = {
  isFirstScreen: boolean;
  isLastScreen: boolean;
};